// eslint-disable-next-line import/no-anonymous-default-export
export default {
  BUGSNAG_API_KEY: String(process.env.REACT_APP_BUGSNAG_API_KEY) || null,
}
